import React, { useEffect, useRef, useState } from "react";
import { addDays } from "../common";
import Day from "./pb/Day";

import { _common } from "../common";
const common = _common;

export default function Platzbelegung(props: { startDate: Date; onReDraw: () => void }) {
  const { startDate, onReDraw } = props;

  const dayOffset = 0;

  var numDays = 7;
  if (common.anzeigeTafelMode) {
    numDays = 1;
  }

  const days: any = [];
  for (var di = 0; di < numDays; di++) {
    const d1 = addDays(startDate, di + dayOffset);
    days.push(<Day key={di} date={d1} onReDraw={onReDraw} />);
  }

  return (
    <div className="days" style={{ width: "100%", padding: "0px" }}>
      {days}
    </div>
  );
}
